export type WithSelection<T> = {
  value: T;
  selected: number;
};

export const withSelection = <T>(value: T, selected: number): WithSelection<T> => {
  return { value, selected };
};
